import { mdiCircleMedium } from '@mdi/js';
import Icon from '@mdi/react';

export const myApprovalsHeaders = {
  RequestID: 'Request ID',
  RequestedBy: 'Request By',
  RequestDate: 'Date',
  RequestType: 'Type',
  Details: 'Details',
};

export const approvalsActions = {
  Approve: 'A',
  Reject: 'R',
};

export const myRequestsHeaders = {
  RequestID: 'Request ID',
  RequestDate: 'Date',
  RequestType: 'Type',
  Details: 'Details',
  Approver: 'Approver',
  Status: 'Status',
};

export const renderRequestLegend = status => {
  const statusMap = {
    'Compensatory Off': { color: '#2E90FA' },
    'Expense Claim': { color: '#7A5AF8' },
    Leave: { color: '#667085' },
    Loan: { color: '#EE46BC' },
    Overtime: { color: '#667085' },
    'Time Registration': { color: '#EF6820' },
    'Travel Request': { color: '#2E90FA' },
    WFH: { color: '#EF6820' },
  };
  const statusColor = statusMap[status]?.color;
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        width: 'fit-content',
        border: '1px solid #e4e7ec',
        borderRadius: '7px',
        padding: '0px 7px',
      }}
    >
      <span className="me-1">
        <Icon path={mdiCircleMedium} size={0.6} color={statusColor} />
      </span>
      <span style={{ fontSize: '12px' }}>{status}</span>
    </div>
  );
};
